var exports = {};
exports = {
  injectInto: null,
  properties: ["spy", "stub", "mock", "clock", "server", "requests", "fake", "replace", "replaceSetter", "replaceGetter", "createStubInstance"],
  useFakeTimers: true,
  useFakeServer: true
};
export default exports;